import Vue from 'vue';

// load transitions
import FadeTransition from './fade-transition';
// import ProductTransition from '@/js/transitions/product-transition';
// import StoryCarouselTransition from '@/js/transitions/story-carousel-transition';
// import SlidingLabelTransition from '@/js/transitions/sliding-label-transition';

// available globally
Vue.component('v-fade-transition', FadeTransition);
// Vue.component('product-transition', ProductTransition);
// Vue.component('story-carousel-transition', StoryCarouselTransition);
// Vue.component('sliding-label-transition', SlidingLabelTransition);